<template>
    <AppMainFormCard :isLoading="isLoading" :tituloTela="tituloTela" :canAdd="false" 
        :isSearch="true" :canSearch="false" :canDelete="false">
        <v-form v-model="isFormValid" ref="formMessage" name="formMessage">
            <v-layout row justify-center>
                <v-flex class="item" xs11 md11>
                    <h3><b>Envio de Mensagens</b></h3>
                </v-flex>
            </v-layout>
            <v-layout row  wrap justify-center>
                <v-flex class="item" xs11 sm11 md9 lg9>
                    <v-autocomplete v-model="registro.estabelecimentos" :items="estabelecimentos" box chips 
                        label="Estabelecimentos" item-text="displayName" item-value="idEstabelecimento" multiple outline>
                        <template slot="selection" slot-scope="data" >
                            <v-chip :selected="data.selected" close class="chip--select-multi" @input="removeEstabelecimento(data.item)" >
                                {{ data.item.displayName }}
                            </v-chip>
                        </template>
                        <template slot="item" slot-scope="data" >
                            <template>
                                <v-list-tile-content>
                                    <v-list-tile-title v-html="data.item.displayName"></v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </template>
                    </v-autocomplete>
                </v-flex>
                <v-flex class="item" xs11 sm11 md2 lg2 pt-5>
                    <v-btn id="selectTodos" rounded color="info" @click="selecionarTodos">
                        <span class="marginSpan"> Todos </span>
                    </v-btn>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md11 lg11>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.stTitulo" label="Título" outline clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center="">
                <v-flex class="item" xs11 md11 lg11>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.stTexto" label="Conteúdo" outline clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout pa-2 pr-8 pl-8>
            <v-flex>
                <AppMainActionsButtonsForm @return="voltar" :canDelete="false" @save="saveRegistro"/>
            </v-flex>
        </v-layout>
    </AppMainFormCard>
</template>

<script>
import { campoObrigatorio, campoSelectObrigatorio } from '@/filters/rules'
import { MensagemSuccessSave } from '@/resourceMessageFile.js'

import AppMainFormCard from '@/components/layout/AppMainFormCard.vue'
import AppMainActionsButtonsForm from '@/components/layout/AppMainActionsButtonsForm.vue'

export default {
    name: 'Farmaco',
    components: {
        AppMainFormCard,
        AppMainActionsButtonsForm,
    },
    data() {
        return{
            isFormValid: false,
            isModified: false,
            registro: {},
            isLoading: false,
            filteredCities: [],
            cdEstabelecimento: 0,
        }
    },
    computed: {
        tituloTela: {
            get() {
                return 'Nova Mensagem'
            }
        },
        estabelecimentos () {
            return this.$store.state.estabelecimentos
        },
        urlAPIMensagens() {
            return process.env.VUE_APP_URL_API_MENSAGENS;
        },
    },
    methods: {
        campoObrigatorio,
        campoSelectObrigatorio,
        selecionarTodos() {
            var context = this
            this.estabelecimentos.forEach(function(x) { 
                context.registro.estabelecimentos.push(x.idEstabelecimento) 
            })
        },
        changeViewState(status, value) {
            if (status == 'isInserting'){
                this.$refs.formMessage.reset()
                this.isLoading = true                
                this.carregarRegistrosLimpos()
                this.isLoading = false
                this.isEditing = false
                this.isModified = false
            } else if (status == 'isError'){
                this.$store.commit('setSnack', {type: 'error', msg : value})
                this.isLoading = false
            } else if (status == 'endLoading'){
                this.isLoading = false
            } else if (status == 'isLoading'){
                this.isLoading = true
            }
        },
        initViewFromRoute() {
            this.$store.dispatch('actLoadEstabelecimentos')
            this.changeViewState('isInserting', null)
        },
        saveRegistro() {
            if (this.$refs.formMessage.validate())
            {
                this.insertRegistro()
            }
        },
        insertRegistro () {
            this.changeViewState('isLoading')
            this.$axios.post(this.urlAPIMensagens, this.registro)
            .then(() => {
                this.$store.commit('setSnack', {type: 'success', msg: MensagemSuccessSave})
                this.changeViewState('endLoading')
            })
            .catch((error) => {
                this.changeViewState('isError', error)
            })
        },
        novoRegistro() {
            this.$router.push({ path: '/envioMensagem' })
        },
        carregarRegistrosLimpos() {
            this.registro = {
                stTitulo: '',
                stTexto: '',
                estabelecimentos: [],
                usuarios: []
            }
        },
        removeEstabelecimento (item) {
            const index = this.registro.estabelecimentos.indexOf(item.idEstabelecimento)
            if (index >= 0) this.registro.estabelecimentos.splice(index, 1)
        },
        voltar() {
            this.$router.go(-1)
        }
    },
    watch: {
        '$route' (to) {
            this.initViewFromRoute(to)
        },
    },
    mounted() {
        this.initViewFromRoute()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
